import { render, staticRenderFns } from "./CookieAccept.vue?vue&type=template&id=35ac56ef&scoped=true&"
import script from "./CookieAccept.vue?vue&type=script&lang=js&"
export * from "./CookieAccept.vue?vue&type=script&lang=js&"
import style0 from "./CookieAccept.vue?vue&type=style&index=0&id=35ac56ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac56ef",
  null
  
)

export default component.exports